import { Form as Bs5Form, InputGroup as Bs5InputGroup } from 'react-bootstrap5';

const Form = Bs5Form;

Object.assign(Form, {
  Group: Bs5Form.Group,
  Label: Bs5Form.Label,
  Control: Bs5Form.Control,
  ControlFeedback: Bs5Form.Control.Feedback,
  Text: Bs5Form.Text,
  InputGroupText: Bs5InputGroup.Text,
  InputGroup: Bs5InputGroup,
  Check: Bs5Form.Check,
  CheckInput: Bs5Form.CheckInput,
  CheckLabel: Bs5Form.CheckLabel,
  Select: Bs5Form.Select,
  Switch: Bs5Form.Switch
});

export default Form;
